import React, { useState } from "react";
import Header from "../../Components/HeaderAdmin/Header";
import "../../assets/css/responsive.css";
import { FaPlay, FaCheck } from "react-icons/fa";
import { Form } from "react-bootstrap";
import VideoUpload from "../DashboardComponents/Video/VideoUpload";
import IronsData from "../DashboardComponents/IronsData/IronsData";
import ImageUpload from "../DashboardComponents/ImageUpload/ImageUpload";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { Accordion } from "react-bootstrap";
import { FaAngleUp } from "react-icons/fa";

function NewFitting() {

    React.useEffect(() => {
        window.scrollTo(0, 0);
    },[])

    const [validated, setValidated] = useState(false);
    const [formData, setFormData] = useState({
        firstname: "",
        lastname: "",
        email: "",
        phone: "",
        height_ft: "",
        height_in: "",
        wrist_to_floor: "",
        shoulder_to_wrist: "",
        elbow_to_wrist: ""
    })

    const dataChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    }

    const handleUpdateSubmit = async (event) => {
        event.preventDefault();
        setValidated(true);
    }

    const options1 = [
        { id: 1, text: 'Straight' },
        { id: 2, text: 'Fade' },
        { id: 3, text: 'Draw' },
        { id: 4, text: 'Slice' },
        { id: 5, text: 'Hook' },
    ];

    const options2 = [
        { id: 1, text: 'Straight' },
        { id: 2, text: 'Fade' },
        { id: 3, text: 'Draw' },
        { id: 4, text: 'Slice' },
        { id: 5, text: 'Hook' },
    ];

    const options3 = [
        { id: 1, text: 'Straight' },
        { id: 2, text: 'Fade' },
        { id: 3, text: 'Draw' },
        { id: 4, text: 'Slice' },
        { id: 5, text: 'Hook' },
    ];

    const shotOpction = [
        { id: 1, text: 'On Target' },
        { id: 2, text: 'Left Of Target' },
        { id: 2, text: 'Right Of Target' },
    ]




    const [currentStep, setCurrentStep] = useState(1);

    const handleNextStep = () => {
        setCurrentStep(currentStep + 1);
    };

    const handlePrevStep = () => {
        setCurrentStep(currentStep - 1);
    };

    const renderStepContent = () => {
        switch (currentStep) {
            case 1:
                return (
                    <div className="step-content-item step-content-item-active w-100 step-1">
                        <div className="step">
                            <div class="sec-header-dash">
                                <div class="box-title mb-0" style={{ color: '#ffffff' }}>
                                    <h3>Customer</h3>
                                </div>
                                <div class="content-box-btn">
                                    <button class="btn btn-add">Edit</button>
                                </div>
                            </div>
                            <div className="dashboard-sec">
                                <div className="container-fulid">
                                    <Form noValidate validated={validated} onSubmit={handleUpdateSubmit}>
                                        <fieldset>
                                            <div className="form-box-section mt-4">
                                                <div className="form-box-inner">
                                                    <div className="form-item">
                                                        <div className="form-group custom-form-group">
                                                            <label className="dashboard-form-lable">Name</label>
                                                            <input type="text"
                                                                required
                                                                className="form-control dashboard-input-box-3 me-1"
                                                                placeholder="First"
                                                                value={formData.firstname}
                                                                name={"firstname"}
                                                            />
                                                            <input type="text"
                                                                required
                                                                className="form-control dashboard-input-box-3 me-1"
                                                                placeholder="Last"
                                                                name={"lastname"}
                                                                value={formData.lastname}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="form-item">
                                                        <div className="form-group custom-form-group">
                                                            <Form.Label className="dashboard-form-lable">Email</Form.Label>
                                                            <Form.Control
                                                                type="email"
                                                                className="form-control dashboard-input-box-3 me-1"
                                                                placeholder="Email Address"
                                                                name="email"
                                                                value={formData.email}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="form-item">
                                                        <div className="form-group custom-form-group">
                                                            <label className="dashboard-form-lable">Phone</label>
                                                            <input type="number" name={"phone"} className="form-control dashboard-input-box-3" placeholder="Phone Number" value={formData.phone} onChange={(e) => dataChange(e)} />
                                                        </div>
                                                    </div>
                                                    <div className="form-item">
                                                        <div className="form-group custom-form-group">
                                                            <label className="dashboard-form-lable">Height</label>
                                                            <div className="d-flex justify-content-end gap-2">
                                                                <input type="number" className="form-control dashboard-input-box w-30" name={"height_ft"} placeholder="ft." value={formData.height_ft} onChange={(e) => dataChange(e)} />
                                                                <input type="number" className="form-control dashboard-input-box w-30" name={"height_in"} placeholder="in." value={formData.height_in} onChange={(e) => dataChange(e)} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </fieldset>
                                    </Form>
                                </div>
                            </div>
                            <div class="sec-header-dash">
                                <div class="box-title mb-0" style={{ color: '#ffffff' }}>
                                    <h3>Golf Swing</h3>
                                </div>
                            </div>
                            <div class="dashboard-sec">
                                <div className="bg_color_dark">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="d-flex justify-content-center gap-2">
                                                <VideoUpload />
                                                <VideoUpload />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            case 2:
                return (
                    <div className="step-content-item w-100 step-2">
                        <div className="sec-header-dash white">
                            <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                <h3>
                                    <span className="color"></span> White Irons
                                </h3>
                            </div>
                        </div>
                        <div>
                            <IronsData title="White Iron" number={'1'} options={options1} shotOpction={shotOpction} />
                            <IronsData title="White Iron" number={'2'} options={options2} shotOpction={shotOpction} />
                            <IronsData title="White Iron" number={'3'} options={options3} shotOpction={shotOpction} />
                        </div>
                        <ImageUpload />
                    </div>
                );
            case 3:
                return (
                    <div className="step-content-item black w-100 step-3">
                        <div className="sec-header-dash">
                            <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                <h3>
                                    <span className="color"></span> Black Irons
                                </h3>
                            </div>
                        </div>
                        <div>
                            <IronsData title="Black Iron" number={'1'} options={options1} shotOpction={shotOpction} />
                            <IronsData title="Black Iron" number={'2'} options={options2} shotOpction={shotOpction} />
                            <IronsData title="Black Iron" number={'3'} options={options3} shotOpction={shotOpction} />
                        </div>
                        <ImageUpload />
                    </div>
                );
            case 4:
                return (
                    <div className="step-content-item blue w-100 step-4">
                        <div className="sec-header-dash">
                            <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                <h3>
                                    <span className="color"></span> Blue Irons
                                </h3>
                            </div>
                        </div>
                        <div>
                            <IronsData title="Blue Iron" number={'1'} options={options1} shotOpction={shotOpction} />
                            <IronsData title="Blue Iron" number={'2'} options={options2} shotOpction={shotOpction} />
                            <IronsData title="Blue Iron" number={'3'} options={options3} shotOpction={shotOpction} />
                        </div>
                        <ImageUpload />
                    </div>
                );
            case 5:
                return (
                    <div className="step-content-item pink w-100 step-5">
                        <div className="sec-header-dash">
                            <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                <h3>
                                    <span className="color"></span> Pink Irons
                                </h3>
                            </div>

                        </div>
                        <div>
                            <IronsData title="Pink Iron" number={'1'} options={options1} shotOpction={shotOpction} />
                            <IronsData title="Pink Iron" number={'2'} options={options2} shotOpction={shotOpction} />
                            <IronsData title="Pink Iron" number={'3'} options={options3} shotOpction={shotOpction} />
                        </div>
                        <ImageUpload />
                    </div>
                );
            case 6:
                return (
                    <div className="step-content-item purpal w-100 step-6">
                        <div className="sec-header-dash">
                            <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                <h3>
                                    <span className="color"></span> Purple Irons
                                </h3>
                            </div>
                        </div>
                        <div>
                            <IronsData title="Purple Iron" number={'1'} options={options1} shotOpction={shotOpction} />
                            <IronsData title="Purple Iron" number={'2'} options={options2} shotOpction={shotOpction} />
                            <IronsData title="Purple Iron" number={'3'} options={options3} shotOpction={shotOpction} />
                        </div>
                        <ImageUpload />
                    </div>
                );
            case 7:
                return (
                    <div className="step-content-item red w-100 step-7">
                        <div className="sec-header-dash">
                            <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                <h3>
                                    <span className="color"></span> Red Irons
                                </h3>
                            </div>

                        </div>
                        <div>
                            <IronsData title="Red Iron" number={'1'} options={options1} shotOpction={shotOpction} />
                            <IronsData title="Red Iron" number={'2'} options={options2} shotOpction={shotOpction} />
                            <IronsData title="Red Iron" number={'3'} options={options3} shotOpction={shotOpction} />
                        </div>
                        <ImageUpload />
                    </div>
                );
            case 8:
                return (
                    <div className="step-content-item orange w-100 step-8">
                        <div className="sec-header-dash">
                            <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                <h3>
                                    <span className="color"></span> Orange Irons
                                </h3>
                            </div>

                        </div>
                        <div>
                            <IronsData title="Orange Iron" number={'1'} options={options1} shotOpction={shotOpction} />
                            <IronsData title="Orange Iron" number={'2'} options={options2} shotOpction={shotOpction} />
                            <IronsData title="Orange Iron" number={'3'} options={options3} shotOpction={shotOpction} />
                        </div>
                        <ImageUpload />
                    </div>
                );
            case 9:
                return (
                    <div className="step-content-item w-100 step-9">
                        <div class="sec-header-dash">
                            <div class="box-title mb-0" style={{ color: '#ffffff' }}>
                                <h3>Fitter Notes</h3>
                            </div>
                        </div>

                        <div className="dashboard-sec">
                            <div className="form-box-section mb-3">
                                <textarea className="dashboard-text-area" id="exampleFormControlTextarea1" rows="8" placeholder="Leave your note here..."></textarea>
                            </div>
                        </div>

                        <buton className="btn btn-colr-white active mt-3 mb-3 d-flex justify-content-center align-items-center btn-fitting-submit">Submit Your Fitting</buton>
                    </div>
                );
            default:
                return null;
        }
    };

    const currentStepName = () => {
        switch (currentStep) {
            case 1:
                return "Get Started";
            case 2:
                return "Get Started";
            case 3:
                return "White Irons";
            case 4:
                return "Black Irons";
            case 5:
                return "Blue Irons";
            case 6:
                return "Pink Irons";
            case 7:
                return "Purple Irons";
            case 8:
                return "Red Irons";
            case 9:
                return "Orange Irons";

            default:
                return null;
        }
    };

    const nextStepName = () => {
        switch (currentStep + 1) {
            case 2:
                return "White Irons";
            case 3:
                return "Black Irons";
            case 4:
                return "Blue Irons";
            case 5:
                return "Pink Irons";
            case 6:
                return "Purple Irons";
            case 7:
                return "Red Irons";
            case 8:
                return "Orange Irons";
            case 9:
                return "Finish Up";
            case 10:
                return "Submit Fitting";

            default:
                return null;
        }
    };



    return (
        <>
            <div className="main-page-body-content-header">
                <Header />
            </div>
            <div className="dashboard-container d-flex">
                <div className="main-container">
                    <div className="main-page-body-content">
                        <div className="main-page-body-content-body">
                            <div className="main-page-body-content-body-container">
                                <div className="container-fluid">
                                    <div>
                                        <div className="step-btn">
                                            <div className="step-btn-item">
                                                <button
                                                    className="btn step-btn-view step-left-btn"
                                                    onClick={handlePrevStep}
                                                    disabled={currentStep === 1}
                                                >
                                                    {currentStep !== 1 && <FaChevronLeft />}
                                                    <div className="pr_content m-0 step_pr_content">
                                                        <h6>Step {currentStep - 0}</h6>
                                                        <h4>{currentStepName()}</h4>
                                                    </div>
                                                </button>
                                            </div>
                                            <div className="step-btn-item">
                                                <button
                                                    className="btn step-btn-view step-right-btn"
                                                    onClick={handleNextStep}
                                                    disabled={currentStep === 9}
                                                >
                                                    <div className="pr_content m-0 step_pr_content text-right">
                                                        <h6>Step {currentStep + 1}</h6>
                                                        <h4>{nextStepName()}</h4>
                                                    </div>
                                                    {currentStep !== 9 && <FaChevronRight />}
                                                </button>
                                            </div>
                                        </div>
                                        <div className="step-content">{renderStepContent()}</div>
                                        <div className="step-btn">
                                            <div className="step-btn-item">
                                                <button
                                                    className="btn step-btn-view step-left-btn"
                                                    onClick={handlePrevStep}
                                                    disabled={currentStep === 1}
                                                >
                                                    {currentStep !== 1 && <FaChevronLeft />}
                                                    <div className="pr_content m-0 step_pr_content">
                                                        <h6>Step {currentStep - 0}</h6>
                                                        <h4>{currentStepName()}</h4>
                                                    </div>
                                                </button>
                                            </div>
                                            <div className="step-btn-item">
                                                <button
                                                    className="btn step-btn-view step-right-btn"
                                                    onClick={handleNextStep}
                                                    disabled={currentStep === 9}
                                                >
                                                    <div className="pr_content m-0 step_pr_content text-right">
                                                        <h6>Step {currentStep + 1}</h6>
                                                        <h4>{nextStepName()}</h4>
                                                    </div>
                                                    {currentStep !== 9 && <FaChevronRight />}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default NewFitting;